export default "__VITE_ASSET__5cd012ee__"